import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39d40e32"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "truncate" }

interface Props {
  text: string,
  href: string,
  isActive?: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    text: null,
    href: null,
    isActive: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["link", { 'is-active': __props.isActive }]),
    href: __props.href
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.text), 1)
  ], 10, _hoisted_1))
}
}

})